import React, { ReactElement } from 'react';
import Svg, { G, Path } from 'react-native-svg';

import { IconStyles } from './types';

export const Sound = ({
  size,
  style,
}: {
  size: number;
  style?: IconStyles;
}): ReactElement => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" style={style}>
      <G stroke="none" fill="none">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.606 4.0484C13.458 3.96911 13.2815 3.98855 13.1509 4.09708L7.63485 8.68445H4.43285C4.19392 8.68445 4 8.89401 4 9.15264V14.8475C4 15.1061 4.19374 15.3156 4.43285 15.3156H7.63485L13.1514 19.903C13.2285 19.9671 13.3213 20 13.4151 20C13.4802 20 13.5457 19.9842 13.6062 19.9517C13.754 19.8728 13.8478 19.71 13.8478 19.5318L13.8474 4.46828C13.8476 4.29009 13.7538 4.12691 13.606 4.0484ZM8.04564 14.4761C7.97021 14.4133 7.87734 14.3793 7.7818 14.3793H4.8657V9.62063H7.78198C7.87752 9.62063 7.97038 9.58657 8.04599 9.52384L12.9821 5.4187L12.9824 18.5812L8.04564 14.4761ZM17.4636 5.36577C17.2945 5.18277 17.0204 5.18277 16.8516 5.36577C16.6825 5.54858 16.6825 5.84492 16.8516 6.02773C19.8961 9.32081 19.8961 14.6793 16.8516 17.9723C16.6825 18.1553 16.6825 18.4515 16.8516 18.6343C16.9362 18.7259 17.0469 18.7715 17.1576 18.7715C17.2684 18.7715 17.3791 18.7259 17.4637 18.6343C20.8454 14.9762 20.8454 9.02389 17.4636 5.36577ZM15.1033 7.25674C15.2723 7.07393 15.5463 7.07393 15.7154 7.25674C16.8866 8.52371 17.5319 10.2081 17.5321 11.9998C17.5321 13.7913 16.8868 15.4761 15.7156 16.743C15.6309 16.8344 15.5203 16.8802 15.4094 16.8802C15.2988 16.8802 15.1879 16.8344 15.1034 16.743C14.9344 16.5602 14.9344 16.2639 15.1034 16.0811C16.1111 14.9909 16.6662 13.5415 16.6662 11.9998C16.6662 10.458 16.1111 9.00882 15.1034 7.9187C14.9344 7.73608 14.9344 7.43974 15.1033 7.25674Z"
          fill={style?.color || 'currentColor'}
        />
      </G>
    </Svg>
  );
};
